import axios from 'axios';
import config from '@/config/environment-config';

const steamAPI = axios.create({
		baseURL: '/api/wallet/v1',
	}),
	getSteamProducts = (params = {}) => steamAPI.get('/products?serviceType=steam', { params }),
	getSteamCheckoutToken = (params = {}) =>
		steamAPI.post(
			'/checkout/methods/steam',
			{ productId: params.productId },
			{ params: { gamecode: params.gamecode, session: params.session } }
		),
	steamPurchaseAPI = {
		install(Vue) {
			Vue.prototype.$steamPurchaseAPI = {
				getSteamProducts,
				getSteamCheckoutToken,
			};
		},
	};

steamAPI.interceptors.response.use(
	(response) => {
		return response;
	},
	(error) => {
		const urlParams = new URLSearchParams(window.location.search);
		const gamecode = urlParams.has('gamecode') ? urlParams.get('gamecode') : '';
		const checkoutFailedUrl = new URL(
			`${config[process.env.NODE_ENV][environment.region].checkout}${process.env.NODE_ENV === 'local' ? '/en' : ''}/steam-result`
		);

		if (error.response && error.response.data && error.response.data.code) {
			checkoutFailedUrl.searchParams.set('error_code', error.response.data.code);
		}
		checkoutFailedUrl.searchParams.set('app_type', 'steam');
		if (gamecode) checkoutFailedUrl.searchParams.set('gamecode', gamecode);

		window.location = checkoutFailedUrl;
		return Promise.reject(error);
	}
);
export default steamPurchaseAPI;
export { getSteamProducts, getSteamCheckoutToken };
